// Stub for common peregrine hooks
import { useEffect, useState } from 'react';

export function useScrollLock(isLocked) {
    useEffect(() => {
        if (isLocked) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isLocked]);
}

export function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        innerWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
        innerHeight: typeof window !== 'undefined' ? window.innerHeight : 768,
        outerWidth: typeof window !== 'undefined' ? window.outerWidth : 1024,
        outerHeight: typeof window !== 'undefined' ? window.outerHeight : 768
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight,
                outerWidth: window.outerWidth,
                outerHeight: window.outerHeight
            });
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
}

export function useToasts() {
    const addToast = (config) => {
        console.log('Toast:', config);
    };

    return [
        { toasts: new Map() },
        { addToast }
    ];
}
